import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

export default function ReportCancelDialog({ isOpen, onClose, onCancel }) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Cancel this run?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This will stop the in-progress analysis. This can't be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Keep Running</Button>
        <Button onClick={onCancel} color="secondary" autoFocus>
          Yes, Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
